<div class="scrollbar">
  <div class="px-2 mt-4 row" [formGroup]="dynamicForm">
    <div class="row">
      <div class="col-12 mb-3">
        <div class="d-flex align-items-center flex-wrap">
          <!-- Model (left col) + Units (right col) — same 50/50 grid as form fields -->
          <div class="col-lg-6 col-md-12 col-sm-12 mb-2" *ngIf="tab === 'model'">
            <div class="d-flex align-items-center gap-4">
              <label class="fw-semibold mb-0" for="modelSelectDropdown">Model *</label>
              <select
                id="modelSelectDropdown"
                #modelSelect
                [formControlName]="FIELD_NAMES.SELECTED_MODEL"
                class="form-control form-select text-center model-select"
                title="Select a model">
                <option value="" disabled selected>Select a Model</option>
                <option *ngFor="let model of models" [value]="model">
                  {{ model }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-lg-6 col-md-12 col-sm-12 mb-2">
            <fieldset class="d-flex align-items-center gap-0 border-0 p-0 m-0 units-fieldset">
              <legend class="visually-hidden">Units</legend>
              <span class="fw-semibold me-5" aria-hidden="true">Units:</span>
              <div class="form-check mb-0">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControlName]="FIELD_NAMES.UNIT_TYPE"
                  [value]="UNIT_TYPES.SI"
                  id="siUnits" />
                <label class="form-check-label" for="siUnits">SI Units</label>
              </div>
              <div class="form-check mb-0">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControlName]="FIELD_NAMES.UNIT_TYPE"
                  [value]="UNIT_TYPES.US"
                  id="usUnits" />
                <label class="form-check-label" for="usUnits">US Units</label>
              </div>
            </fieldset>
          </div>

          <!-- BLOWER OPERATING POINT -->
          <div class="w-100 mt-3">
            <div class="section-title text-primary fw-bold">Blower Operating Point</div>
          </div>

          <!-- Reusable field control template to avoid duplicated markup -->
          <ng-template #fieldControl let-field>
            <div class="col-lg-6 col-md-12 col-sm-12 custom-col">
              <div class="col-lg-6 col-md-12 col-sm-12 flex-wrapper d-flex align-items-center gap-3 mb-3">
                <div class="label-required">
                  <label class="field-label fw-semibold" [for]="field?.name">
                    {{ field.label }}
                    <strong *ngIf="field.required">*</strong>
                  </label>
                </div>

                <ng-container [ngSwitch]="field?.type">
                  <div class="all-input col-md-6 w-25">
                    <input
                      *ngSwitchCase="FIELD_TYPES.NUMBER"
                      class="form-control w-100"
                      type="number"
                      step="0.01"
                      [formControlName]="field?.name"
                      [value]="field?.value"
                      [required]="field?.required"
                      [min]="convertedMinMax[field.name] ? convertedMinMax[field.name].min : field.min"
                      [max]="convertedMinMax[field.name] ? convertedMinMax[field.name].max : field.max"
                      (blur)="onInputChange($event, field)"
                      [id]="field?.name" />

                    <input
                      *ngSwitchCase="FIELD_TYPES.TEXT"
                      type="text"
                      class="form-control w-100"
                      [formControlName]="field?.name"
                      [value]="field?.value"
                      [required]="field?.required"
                      [min]="convertedMinMax[field.name] ? convertedMinMax[field.name].min : field.min"
                      [max]="convertedMinMax[field.name] ? convertedMinMax[field.name].max : field.max"
                      (blur)="onInputChange($event, field)"
                      [id]="field?.name" />

                    <select
                      *ngSwitchCase="FIELD_TYPES.DROPDOWN"
                      class="form-control form-select w-100"
                      [formControlName]="field?.name"
                      [required]="field?.required"
                      [id]="field?.name">
                      <option *ngFor="let option of field?.options" [value]="option">
                        {{ option }}
                      </option>
                    </select>
                  </div>

                  <div class="unit-dropdown col-md-6 w-50" *ngIf="field.units">
                    <select
                      class="form-control form-select text-center w-75"
                      (change)="onUnitChange($event, field)"
                      [id]="field?.name + '_units'">
                      <option *ngFor="let unit of field.units" [value]="unit" [selected]="unit === selectedUnits[field.name]">
                        {{ unit }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-6" *ngIf="!field.units">
                    <div>{{ field.unitValue }}</div>
                  </div>
                </ng-container>
              </div>

              <div *ngIf="dynamicForm.get(field.name)?.invalid && dynamicForm.get(field.name)?.touched" class="text-danger mt-1">
                <div *ngIf="dynamicForm.get(field.name)?.errors?.['min']">
                  Please enter a value greater than or equal to
                  {{ convertedMinMax[field.name]?.min ?? field.min }}
                  {{
                    selectedUnits[field.name]
                      ? ' ' + selectedUnits[field.name]
                      : field.unitValue
                        ? ' ' + field.unitValue
                        : field.baseUnit
                          ? ' ' + field.baseUnit
                          : ''
                  }}.
                </div>
                <div *ngIf="dynamicForm.get(field.name)?.errors?.['max']">
                  Please enter a value less than or equal to
                  {{ convertedMinMax[field.name]?.max ?? field.max }}
                  {{
                    selectedUnits[field.name]
                      ? ' ' + selectedUnits[field.name]
                      : field.unitValue
                        ? ' ' + field.unitValue
                        : field.baseUnit
                          ? ' ' + field.baseUnit
                          : ''
                  }}.
                </div>
                <div *ngIf="dynamicForm.get(field.name)?.errors?.['required']">This field is required.</div>
              </div>
            </div>
          </ng-template>

          <ng-container *ngFor="let field of blowerOperatingFields; let i = index">
            <ng-container *ngTemplateOutlet="fieldControl; context: { $implicit: field }"></ng-container>
          </ng-container>

          <!-- HEAT RECOVERY POTENTIAL -->
          <div class="w-100 mt-3" *ngIf="heatRecoveryUsed">
            <div class="section-title text-primary fw-bold">Heat Recovery Potential</div>
          </div>
          <ng-container *ngIf="heatRecoveryUsed">
            <ng-container *ngFor="let field of heatRecoveryFields; let i = index">
              <ng-container *ngTemplateOutlet="fieldControl; context: { $implicit: field }"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
